import { antecedentesApi } from "../view/antecedentes.service";
import { reshape_response } from "../../../../helpers/functions";

export const getAntecedenteById = antecedentesApi.injectEndpoints({
  endpoints: (builder) => ({
    getAntecedenteById: builder.query({
      query: (id) => `/v1/api/antecedenteacademico/${id}/`,
      providesTags: (result, error, id) => [{ type: "Antecedentes", id }],
      transformResponse: (response, meta, args) => {
        return reshape_response(response, args.shape);
      },
    }),
  }),
});

export const { useGetAntecedenteByIdQuery } = getAntecedenteById;
